@for (adv of adversitings(); track $index) {
  @if (adv.language && adv?.language?.header_color != null) {
    <div class="row d-md-block">
      <div class="col-12">
        <div class="box box-np text-center">
          <div
            class="box-header"
            [ngStyle]="{ 'background-color': adv?.language?.header_color }"
          >
            <h2>{{ adv?.language?.title }}</h2>
          </div>
          <a
            href="{{ adv?.language?.url_banner }}"
            target="_blank"
            class="d-inline-block h-100 p-2"
          >
            @if (adv?.language?.banner) {
              <img
                class="w-50"
                [src]="adv.language.banner | cdnUrl: 500 : true"
                alt=""
              />
            }
          </a>
          <div>
            <h2>{{ adv.language.description }}</h2>
          </div>

          @if (adv?.language?.imagen_android) {
            <div class="row downloads">
              <div class="col-6 p-1">
                <a target="_blank" href="{{ adv?.language?.url_android }}">
                  <img
                    class="w-100"
                    [lazyLoad]="
                      adv.language.imagen_android | cdnUrl: 300 : true
                    "
                  />
                </a>
              </div>
              @if (adv?.language?.imagen_ios) {
                <div class="col-6 p-1">
                  <a target="_blank" href="{{ adv?.language?.url_ios }}">
                    <img
                      [lazyLoad]="adv.language.imagen_ios | cdnUrl: 300 : true"
                    />
                  </a>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (adv?.language?.header_color == null) {
    <div class="row">
      <div class="col-12 d-lg-block">
        <div class="box">
          <div class="row">
            <div class="col-12 text-center">
              @if (adv?.language?.url_banner) {
                <a href="{{ adv?.language?.url_banner }}" target="_blank">
                  <img
                    [lazyLoad]="adv.language.banner | cdnUrl: 500 : true"
                    class="w-100 logo"
                  />
                </a>
                @if (adv?.language?.imagen_android) {
                  <div class="row downloads">
                    <div class="col-6 p-1">
                      <a
                        target="_blank"
                        href="{{ adv?.language?.url_android }}"
                      >
                        <img
                          class="w-100"
                          [lazyLoad]="
                            adv.language.imagen_android | cdnUrl: 300 : true
                          "
                        />
                      </a>
                    </div>
                    @if (adv?.language?.imagen_ios) {
                      <div class="col-6 p-1">
                        <a target="_blank" href="{{ adv?.language?.url_ios }}">
                          <img
                            [lazyLoad]="
                              adv.language.imagen_ios | cdnUrl: 300 : true
                            "
                          />
                        </a>
                      </div>
                    }
                  </div>
                }
              } @else {
                <a>
                  <img
                    [lazyLoad]="adv.language.banner | cdnUrl: 500 : true"
                    class="w-100"
                  />
                </a>
                @if (adv?.language?.imagen_android) {
                  <div class="row downloads">
                    <div class="col-6 p-1">
                      <a
                        target="_blank"
                        href="{{ adv?.language?.url_android }}"
                      >
                        <img
                          class="w-100"
                          [lazyLoad]="
                            adv.language.imagen_android | cdnUrl: 300 : true
                          "
                        />
                      </a>
                    </div>
                    @if (adv?.language?.imagen_ios) {
                      <div class="col-6 p-1">
                        <a target="_blank" href="{{ adv?.language?.url_ios }}">
                          <img
                            [lazyLoad]="
                              adv.language.imagen_ios | cdnUrl: 300 : true
                            "
                          />
                        </a>
                      </div>
                    }
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
